

































import { Art } from '@/shared/models/art';
import Vue from 'vue';
import { mapActions, mapState } from 'vuex';
export default Vue.extend({
  props: {
    artItem: {
      type: Object,
    },
  },
  computed: {
    ...mapState({ user: (state: any): string => state.user.user }),
  },
  methods: {
    ...mapActions('user', ['updateUserCritterInfo']),
    async checkArtItem(artItem: Art) {
      await this.updateUserCritterInfo({ id: artItem.id.toString(), type: 'art' });
    },
  },
});
